import * as React from "react";

import { Alert } from "@replo/design-system/blocks/alert/Alert";
import { LabeledControl } from "@replo/design-system/blocks/labeled-control/LabeledControl";
import { Button } from "@replo/design-system/components/button/Button";
import { Input } from "@replo/design-system/components/input/Input";
import { Separator } from "@replo/design-system/components/separator/Separator";
import GoogleAuth from "@v2/features/account/GoogleAuth";
import { useSearchParams } from "react-router-dom";

import { TermsAndPrivacy } from "./TermsAndPrivacy";
import { useSignupForm } from "./useSignupForm";

const SignupForm = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const shouldShowShopifyLoginInlineAlert =
    searchParams.get("error") === "login_in_to_associate_shopify";

  const {
    emailRegisterProps,
    passwordRegisterProps,
    handleSubmit,
    onSubmit,
    onGoogleSubmit,
    emailError,
    passwordError,
    isLoadingCreateAccount,
    buttonShouldBeDisabled,
    displayErrorMessage,
  } = useSignupForm();

  const removeSearchParam = () => {
    setSearchParams((previous) => {
      const newParams = new URLSearchParams(previous);
      newParams.delete("error");
      return newParams;
    });
  };

  return (
    <form
      className="no-scrollbar"
      onSubmit={(data) => {
        if (shouldShowShopifyLoginInlineAlert) {
          removeSearchParam();
        }
        void handleSubmit(onSubmit)(data);
      }}
    >
      {(displayErrorMessage || shouldShowShopifyLoginInlineAlert) && (
        <Alert
          variant={
            shouldShowShopifyLoginInlineAlert && !displayErrorMessage
              ? "warning"
              : "error"
          }
          UNSAFE_className="mb-2"
          description={
            displayErrorMessage ??
            "Please create or log in to your Replo account to continue to Replo."
          }
        />
      )}
      <div className="flex flex-col gap-4">
        <LabeledControl label="Email" size="base" id="email" error={emailError}>
          <Input
            id="email"
            invalid={Boolean(emailError)}
            autoComplete="off"
            placeholder="Your Work Email"
            {...emailRegisterProps}
            type="email"
            size="base"
          />
        </LabeledControl>
        <LabeledControl
          label="Password"
          size="base"
          id="password"
          error={passwordError}
        >
          <Input
            id="password"
            invalid={Boolean(passwordError)}
            autoComplete="off"
            placeholder="••••••••••••"
            {...passwordRegisterProps}
            type="password"
            size="base"
          />
        </LabeledControl>
      </div>
      <div className="mt-10">
        <TermsAndPrivacy />
      </div>
      <Button
        className="w-full"
        UNSAFE_className="mt-6"
        variant="primary"
        size="base"
        type="submit"
        loading={isLoadingCreateAccount}
        disabled={buttonShouldBeDisabled}
      >
        Create Account
      </Button>
      <Separator className="my-4" />
      <GoogleAuth handleGoogleCredentials={onGoogleSubmit} />
    </form>
  );
};

export default SignupForm;
